module.exports = __webpack_public_path__ + "static/media/MBOX-BNB.5ff3d22b.svg";